import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=d652ffaa&scoped=true&"
import script from "./StartScreen.vue?vue&type=script&lang=ts&"
export * from "./StartScreen.vue?vue&type=script&lang=ts&"
import style0 from "./StartScreen.vue?vue&type=style&index=0&id=d652ffaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d652ffaa",
  null
  
)

export default component.exports